import type { FormikErrors } from 'formik';
import getFieldErrorNames from '../getFieldErrosNames';

type CheckErrorsTypes = {
  errors: FormikErrors<{ [field: string]: unknown }>;
  nationalityRef: React.MutableRefObject<HTMLDivElement | null>;
  cpfFileRef: React.MutableRefObject<HTMLDivElement | null>;
  rgFileRef: React.MutableRefObject<HTMLDivElement | null>;
  proofOfAddressRef: React.MutableRefObject<HTMLDivElement | null>;
  selfieWithDocumentRef: React.MutableRefObject<HTMLDivElement | null>;
  degreeOfRelatednessRef?: React.MutableRefObject<HTMLDivElement | null>;
};

const checkErrors = (props: CheckErrorsTypes): void => {
  const {
    errors,
    degreeOfRelatednessRef,
    cpfFileRef,
    nationalityRef,
    proofOfAddressRef,
    rgFileRef,
    selfieWithDocumentRef,
  } = props;
  const fieldErrorNames = getFieldErrorNames(errors);
  if (fieldErrorNames.length <= 0) return;

  const element = document.querySelector(`input[name='${fieldErrorNames[0]}']`);
  if (!element) return;

  const inputType = element.getAttribute('type');
  if (inputType === 'radio') {
    if (
      fieldErrorNames[0] === 'degree_of_relatedness' &&
      degreeOfRelatednessRef &&
      degreeOfRelatednessRef.current
    ) {
      degreeOfRelatednessRef.current.scrollIntoView();
    }
    if (
      fieldErrorNames[0] === 'nationality' &&
      nationalityRef &&
      nationalityRef.current
    ) {
      nationalityRef.current.scrollIntoView();
    }
  }
  if (inputType === 'file') {
    if (fieldErrorNames[0] === 'cpfFile' && cpfFileRef && cpfFileRef.current) {
      cpfFileRef.current.scrollIntoView();
    }
    if (fieldErrorNames[0] === 'rgFile' && rgFileRef && rgFileRef.current) {
      rgFileRef.current.scrollIntoView();
    }
    if (
      fieldErrorNames[0] === 'proofOfAddress' &&
      proofOfAddressRef &&
      proofOfAddressRef.current
    ) {
      proofOfAddressRef.current.scrollIntoView();
    }
    if (
      fieldErrorNames[0] === 'selfieWithDocument' &&
      selfieWithDocumentRef &&
      selfieWithDocumentRef.current
    ) {
      selfieWithDocumentRef.current.scrollIntoView();
    }
  }
};

export default checkErrors;
